import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  CartesianGrid, Line, LineChart, Tooltip, XAxis, YAxis,
} from 'recharts';
import SearchIcon from '@material-ui/icons/Search';
import { IconButton } from '@material-ui/core';
import { toast } from 'react-toastify';
import { findMapaBordero, findUsuariosPermitidos } from '../../../services/core/controleBordero/controleBordero.service';
import Grid24 from '../../../components/UI/Grid24';
import DateField from '../../../components/UI/Field/Date/DateField';
import { ButtonUI, SelectorField } from '../../../components';
import useStyle, { ContainerPrincipal, WrapperFormWithTitle } from './MapaBorderoStyles';
import { getCurrentIdUsuario, getMoneyMask } from '../../../helpers';
import SelectorModel from '../../../models/SelectorModel';
import TabelaClientes from './TabelaClientes';
import { mapaBorderoFactory } from './MapaBorderoFactory';


function MapaBorderoComponent() {
  const styles = useStyle();

  const [dataBase, setDataBase] = useState('');
  const [mapaBordero, setMapaBordero] = useState([]);
  const [mapaBorderoClientesAtivos, setMapaBorderoClientesAtivos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSelecionado, setUsuariosSelecionado] = useState(0);
  const [isQtdProcessos, setIsQtdProcessos] = useState(true);
  const [clienteAtivo, setClienteAtivo] = useState(true);

  useEffect(() => {
    if (usuarios.length === 0) {
      findUsuariosPermitidos(getCurrentIdUsuario()).then((response) => {
        const resposta = response.data.map(usuario => (new SelectorModel(usuario.idUsuario, usuario.nomeUsuario)));
        setUsuarios(resposta);
      });
    }
  },
  [usuarios]);

  const onSubmitHandler = useCallback(() => {
    findMapaBordero(dataBase, usuarioSelecionado).then((response) => {
      setMapaBordero(response.data);
      setMapaBorderoClientesAtivos(response.data.filter(cliente => cliente.statusCliente === 'A'));
      if (response.data.length === 0) {
        toast.warn('Nenhum resultado foi encontrado relacionado à sua pesquisa');
      }
    });
  }, [dataBase, usuarioSelecionado]);

  return (
    <ContainerPrincipal>
      <Grid24 item xs={24} sm={16} style={{ margin: '5px' }}>
        <div style={{ margin: '5px' }}>
          <DateField
            isForm
            disabled={usuarios.length === 0}
            label="Data de Referência"
            name="Data de Referência"
            value={dataBase}
            onChange={e => setDataBase(e.target.value)}
          />
        </div>
        <div style={{ margin: '5px', width: '300px' }}>
          <SelectorField
            isForm
            disabled={usuarios.length === 0}
            label="Contato"
            items={usuarios}
            name={usuarioSelecionado.name}
            value={usuarioSelecionado.value}
            onChange={(event) => { setUsuariosSelecionado(event.target.value); }}
          />
        </div>
        <div style={{ marginTop: 'auto' }}>
          <IconButton
            onClick={onSubmitHandler}
            disabled={usuarioSelecionado === 0 || dataBase === ''}
            type="submit"
            className={styles.button}
          >
            <SearchIcon />
          </IconButton>
        </div>
        <div style={{ marginTop: 'auto', marginLeft: '5px' }}>
          <ButtonUI
            color="success"
            style={{ width: '220px' }}
            disabled={mapaBordero.length === 0}
            onClick={() => setIsQtdProcessos(!isQtdProcessos)}
          >
            {isQtdProcessos ? ('Valores do Processo') : ('Quantidade de Processos')}
          </ButtonUI>
        </div>
        <div style={{ marginTop: 'auto', marginLeft: '5px' }}>
          <ButtonUI
            color="success"
            style={{ width: '200px' }}
            disabled={mapaBordero.length === 0}
            onClick={() => setClienteAtivo(!clienteAtivo)}
          >
            {clienteAtivo ? ('Todos os Clientes') : ('Clientes Ativos')}
          </ButtonUI>
        </div>
      </Grid24>
      <Grid24 item xs={24} sm={24}>
        <div style={{ margin: '5px' }}>
          <WrapperFormWithTitle title={`${isQtdProcessos ? 'Quantidade de Processos' : 'Valor do Processo'}  por Cliente`}>
            <LineChart
              width={1025}
              height={300}
              data={mapaBorderoFactory.makeDataGraficoMapaBordero(clienteAtivo ? mapaBorderoClientesAtivos : mapaBordero, isQtdProcessos, dataBase)}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              {mapaBordero.length > 0 && (
              <XAxis dataKey="data" />
              )}
              <YAxis />
              <Tooltip formatter={value => [isQtdProcessos ? `${value}` : `${getMoneyMask(value)}`]} />
              <Line type="monotone" dataKey="item" stroke="#8884d8" activeDot={{ r: 8 }} />
            </LineChart>
          </WrapperFormWithTitle>
        </div>
      </Grid24>
      <Grid24 item xs={24} sm={24}>
        <div style={{ margin: '5px' }}>
          <WrapperFormWithTitle title="Clientes">
            <TabelaClientes
              content={clienteAtivo ? mapaBorderoClientesAtivos : mapaBordero}
              isQtdProcessos={isQtdProcessos}
            />
          </WrapperFormWithTitle>
        </div>
      </Grid24>
    </ContainerPrincipal>
  );
}

export const MapaBordero = withRouter(MapaBorderoComponent);
